import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Comment, CommentCreate } from '@wdx/clmi/clmi-swagger-gen';
import { PaginatedApiResponse } from '@wdx/clmi/api-services/models';
import { Observable } from 'rxjs';
import { PaginationOptions } from '../../models/pagination-options';
import { ApiPaginationService } from '@wdx/shared/infrastructure/api-service';
import { ConfigService } from '../../services/config.service';

@Injectable()
export class CommentsService {
    constructor(
        private http: HttpClient,
        private config: ConfigService,
        private apiPaginationService: ApiPaginationService,
    ) {}

    create(
        activityId: string,
        commentCreateData: CommentCreate,
    ): Observable<Comment> {
        return this.http.post<Comment>(
            `${
                this.config.getConfiguration().API_BASE
            }/activity/${activityId}/comment`,
            commentCreateData,
        );
    }

    getPage(
        paginationOptions: PaginationOptions,
        activityId: string,
    ): Observable<PaginatedApiResponse<Comment>> {
        return this.http.get<PaginatedApiResponse<Comment>>(
            `${
                this.config.getConfiguration().API_BASE
            }/activity/${activityId}/comment`,
            {
                headers:
                    this.apiPaginationService.mapPaginationOptions(
                        paginationOptions,
                    ),
            },
        );
    }
}
